import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Search, Users, ChevronRight } from "lucide-react";
import StudentAssessment from "@/components/StudentAssessment";
import { staffApi, authHeaders, errText, GRADES } from "@/lib/memberAuth";

const inp = "h-10 px-3 border border-border rounded-sm bg-white text-sm focus:outline-none focus:border-primary";

export default function TeacherPanel({ member }) {
  const [students, setStudents] = useState([]);
  const [q, setQ] = useState("");
  const [grade, setGrade] = useState("");
  const [sel, setSel] = useState(null);

  useEffect(() => { staffApi(authHeaders()).students().then(setStudents).catch((e) => toast.error(errText(e))); }, []);

  const list = students.filter((s) => (!grade || s.grade === grade) && (!q || s.name.toLowerCase().includes(q.toLowerCase()) || s.email.includes(q.toLowerCase())));

  return (
    <div data-testid="teacher-panel">
      <div className="bg-primary text-primary-foreground rounded-sm p-6 md:p-8 mb-6">
        <div className="font-mono-accent text-[10px] uppercase tracking-widest text-white/60">Περιοχή Καθηγητών</div>
        <h1 data-testid="members-welcome" className="font-heading font-extrabold text-2xl sm:text-3xl">{member.name}</h1>
        <div className="font-mono-accent text-xs text-accent mt-1">{member.subjects?.length ? member.subjects.join(" · ") : "Καθηγητής/τρια"} · {member.email}</div>
      </div>

      <div className="grid lg:grid-cols-5 gap-6">
        <aside className="lg:col-span-2">
          <h2 className="font-heading font-bold text-lg flex items-center gap-2 mb-3"><Users className="h-5 w-5 text-primary" /> Μαθητές <span className="font-mono-accent text-xs text-muted-foreground font-normal">({list.length})</span></h2>
          <div className="flex gap-2 mb-3">
            <div className="relative flex-1"><Search className="h-4 w-4 absolute left-3 top-3 text-muted-foreground" /><input data-testid="teacher-search" className={`${inp} w-full pl-9`} placeholder="Αναζήτηση μαθητή" value={q} onChange={(e) => setQ(e.target.value)} /></div>
            <select data-testid="teacher-grade-filter" className={inp} value={grade} onChange={(e) => setGrade(e.target.value)}><option value="">Όλες</option>{GRADES.map((g) => <option key={g}>{g}</option>)}</select>
          </div>
          <div className="bg-white border border-border rounded-sm divide-y divide-border max-h-[60vh] overflow-y-auto" data-testid="teacher-students-list">
            {list.length === 0 && <p className="p-5 text-sm text-muted-foreground">{students.length === 0 ? "Δεν σας έχουν ανατεθεί μαθητές ακόμη. Η ανάθεση γίνεται από τη διεύθυνση." : "Δεν βρέθηκαν μαθητές με αυτά τα κριτήρια."}</p>}
            {list.map((s) => (
              <button key={s.id} data-testid={`teacher-student-${s.id}`} onClick={() => setSel(s)} className={`w-full text-left p-3 flex items-center gap-3 transition-colors hover:bg-secondary ${sel?.id === s.id ? "bg-secondary border-l-4 border-primary" : ""}`}>
                <div className="flex-1 min-w-0"><div className="font-medium text-sm truncate">{s.name}</div><div className="text-xs text-muted-foreground truncate">{s.grade || "—"} · {s.email}</div></div>
                <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
              </button>
            ))}
          </div>
        </aside>
        <div className="lg:col-span-3">
          {sel ? <StudentAssessment student={sel} authCfg={authHeaders()} onClose={() => setSel(null)} prefix="teacher" />
            : <div data-testid="teacher-empty" className="bg-white border border-dashed border-border rounded-sm p-10 text-center text-sm text-muted-foreground">Επίλεξε μαθητή από τη λίστα για να καταχωρήσεις βαθμούς διαγωνισμάτων ή αξιολόγηση προόδου.</div>}
        </div>
      </div>
    </div>
  );
}
